<template>
  <div>
    <div v-for="content in contents" :key="content.uid">
      <ul v-if="content.type === 'list'">
        <li class="mt-1" v-for="item in content.content" :key="item">
          {{ item }}
        </li>
      </ul>

      <v-img v-if="content.type === 'img'" :src="content.content"></v-img>
    </div>
  </div>
</template>

<script>
export default {
  name: "ExtraContent",
  props: {
    contents: Array
  }
};
</script>

<style scoped>
li {
  list-style-type: "-";
  padding-inline-start: 1ch;
}
</style>
